document.addEventListener('DOMContentLoaded', () => {
  const getProductForm = () =>
    document.querySelector('product-form form[action*="/cart/add"]') ||
    document.querySelector('form[action*="/cart/add"]');

  const setFormQuantity = (value) => {
    const form = getProductForm();
    if (!form) return;

    // Si ya existe un input de cantidad (nativo de Dawn o de otro bloque), lo reutiliza.
    let input = form.querySelector('input[name="quantity"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'quantity';
      form.appendChild(input);
    }

    input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));

    // Reafirma el valor justo antes de enviar, por si algún otro script
    // (ej. el stepper nativo de Dawn) lo resetea entre el "change" y el submit.
    if (!form.dataset.qsSubmitGuard) {
      form.dataset.qsSubmitGuard = 'true';
      form.addEventListener(
        'submit',
        () => {
          const selected = document.querySelector('.quantity-selector__radio:checked');
          if (selected) input.value = selected.value;
        },
        true
      );
    }
  };

  document.querySelectorAll('.quantity-selector__options').forEach((group) => {
    const radios = group.querySelectorAll('.quantity-selector__radio');

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        radios.forEach((r) => {
          r.closest('.quantity-selector__option').classList.toggle('is-selected', r.checked);
        });
        setFormQuantity(radio.value);
      });
    });

    const initiallyChecked = group.querySelector('.quantity-selector__radio:checked');
    if (initiallyChecked) setFormQuantity(initiallyChecked.value);
  });
});
